'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var affiliateApi = exports.affiliateApi = {
  background_url: 'https://dev-res.thumbr.io/images/api-banner.jpg',
  title: 'API para Afiliados',
  description: 'Accede a todo el contenido de Tutellus y gana dinero en cada Venta con una API Rest muy facilona.',
  get_access: 'Accede a la API',
  get_access_title: 'Accede a la documentación',
  reasons_title: 'Ventajas de ser Afiliado',
  reasons: JSON.stringify(['full_catalog', 'powerful', 'profits', 'analytics']),
  full_catalog_title: 'Todo el catálogo de Cursos',
  full_catalog_icon: 'https://lib.tutellus.com/images/icons/find.svg',
  full_catalog_description: 'Accede a todo nuestro catálogo e intégralo en tu Site como prefieras',
  powerful_title: 'Endpoint versátil y configurable',
  powerful_icon: 'https://lib.tutellus.com/images/icons/filter.svg',
  powerful_description: 'Filtra por Categoría, Contenido, Profesor, Precio… y más.',
  profits_title: '50% de Beneficios para ti. Siempre',
  profits_icon: 'https://lib.tutellus.com/images/icons/50percent.svg',
  profits_description: 'De cada usuario que termine comprando un Curso o Certificado.',
  analytics_title: 'Métricas reales en tu Dashboard',
  analytics_icon: 'https://lib.tutellus.com/images/icons/earn-money.svg',
  analytics_description: 'Descubre qué Campañas y Cursos son más rentables.',
  become_affiliate: 'Hazte Afiliado',
  metrics_title: 'Métricas a tu servicio',
  metrics_image: 'https://dev-res.thumbr.io/images/api-metrics.png',
  metrics_description: 'Te damos un Dashboard donde podrás analizar el impacto de tu trabajo, midiendo las Métricas más relevantes: Visitas, Clics, Beneficio y mucho más.',
  livetest_title: '¡Pruébala ahora!',
  livetest_description: 'El código más abajo obtiene los cursos de Tutellus e imprimie la lista de títulos y sus respectivas URLs.',
  features_title: 'El sistema de Afiliados más rentable y transparente que imagines',
  features: JSON.stringify(['filtering', 'big_data', 'leads']),
  filtering_title: 'Segmentación avanzada',
  filtering_image: 'https://dev-res.thumbr.io/images/api-segmentation.png',
  filtering_description: 'Descubre los cursos que mejor encajan con tu audiencia filtrando por distintos parámetros, niveles y categorías.',
  big_data_title: 'Big Data a tu servicio',
  big_data_image: 'https://dev-res.thumbr.io/images/api-bigdata.png',
  big_data_description: 'Nuestros Algoritmos se encargan de monitorizar tráfico, clics, usuarios y ventas a tiempo real, y de reflejar todo en tu Dashboard.',
  leads_title: 'Cobra por cualquier venta',
  leads_image: 'https://dev-res.thumbr.io/images/api-earn.png',
  leads_description: 'Ganarás un 50% de cualquier compra que realice un usuario que venga por tu enlace de Afiliación durante los siguientes 30 días al clic.',
  terms: 'Términos y condiciones generales de la API para Afiliados',
  choose_a_language: 'Elige tu lenguaje:',
  view_api_docs: 'Accede a la documentación',
  trigger_hint: 'Para ver funcionando la API',
  test_it_out: 'Pruébalo',
  clear_output: 'Limpiar consola'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/affiliate_api.js
// module id = 693
// module chunks = 0